// Libraries
// import { Center, Spinner } from "@chakra-ui/react";
// Graphql
import { useQuery } from "@apollo/client";
import { useRouter } from "next/router";
import React from "react";
// Recoil
import { useRecoilValue, useSetRecoilState } from "recoil";
import ActionLinks from "../../../components/Classes/ActionLinks";
import ClassesStat from "../../../components/Classes/ClassesStat";
import EnrolledClasses from "../../../components/Classes/EnrolledClasses";
// Components
import UserLayout from "../../../components/UserLayoutv2";
import { GET_JOINED_CLASSES } from "../../../graphql/queries/class";
import { PrivateRoute } from "../../../Helpers/PrivateRoute";
import { allClasses, authData } from "../../../State";

// import Dummy from "../../../components/UI/Dummy";

const Enrolled = () => {
  // console.log(process.env.NEXT_PUBLIC_ENDPOINT);
  const router = useRouter();

  // Recoil
  const { loggedIn } = useRecoilValue(authData);
  if (!loggedIn) {
    if (typeof window !== "undefined") {
      router.push("/login");
    }
  }
  const setAllClasses = useSetRecoilState(allClasses);

  const { loading, error, data, refetch } = useQuery(GET_JOINED_CLASSES, {
    fetchPolicy: "cache-first",
    onError: () => {
      return null;
    },
  });

  const classesData = data ? data.get_student_profile.joined_classes : {};
  const waitingList = data ? data.get_student_profile.wait_list : {};

  // remove deleted classes
  let filteredClasses = [];
  let restructuredWaitingList = [];

  if (!loading && classesData.length > 0) {
    // filter out classes that don't have data
    filteredClasses = classesData.filter((singleClass) => {
      return singleClass.class !== null;
    });

    // restructure the waiting list to match enrolled classes
    // waitingList.forEach(classData => {
    //   restructuredWaitingList.push({
    //     class: {
    //       ...classData
    //     }
    //   })
    // });
  }

  if (!loading && waitingList.length > 0) {
    // restructure the waiting list to match enrolled classes
    waitingList.forEach((classData) => {
      restructuredWaitingList.push({
        class: {
          ...classData,
        },
      });
    });
  }

  let classesToDisplay;

  if (!loading) {
    classesToDisplay = [...restructuredWaitingList, ...filteredClasses];

    // set allClasses to the filtered classes
    setAllClasses(classesToDisplay);
  }

  // const Loader = () => (
  //   <Center h="100vh">
  //     <Spinner />
  //   </Center>
  // );

  // const pushAway = ()=>{
  // if(!loggedIn){
  //  redirectToLogin()
  // }
  // }
  // useEffect(() => {
  //   pushAway();
  // }, [])
  // console.log(waitingList);
  // console.log(classesToDisplay);
  return (
    <UserLayout
      title="My Classes"
      rightDisplay={{ base: "none", lg: "block" }}
      leftDisplay={{ base: "none", lg: "block" }}
      left={<ActionLinks />}
      applyTopMargin={false}
      main={
        <EnrolledClasses
          classesData={classesToDisplay}
          isLoading={loading}
          error={error}
          refetch={refetch}
        />
      }
      right={<ClassesStat classesData={classesToDisplay} isLoading={loading} />}
      // right={<Dummy />}
    />
  );
};

export default PrivateRoute(Enrolled);
